import { SignIn } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";
import { loginHead, validateLoginSearch } from "~/lib/login-search.ts";

/**
 * FlirtMachine customer login page
 *
 * Reachable at `flirtmachine.app/login` (and `localhost/login` in dev). This is
 * the brand's customer door — it encodes *intent* ("sign in to my account"), so
 * after sign-in it lands the user on their dashboard regardless of role. Admins
 * who want the admin console use `/admin/login` instead. Authorization for the
 * admin area is enforced by the `/admin` route guard, not by this redirect.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/flirtmachine/login/")({
  validateSearch: validateLoginSearch,
  head: () => loginHead("FlirtMachine"),
  component: FlirtMachineLogin,
});

export function FlirtMachineLogin() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <SignIn
        routing="path"
        path="/login"
        fallbackRedirectUrl="/flirtmachine/dashboard"
      />
    </div>
  );
}
